import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39b8a106&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=39b8a106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8a106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b8a106')) {
      api.createRecord('39b8a106', component.options)
    } else {
      api.reload('39b8a106', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39b8a106&scoped=true&", function () {
      api.rerender('39b8a106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mysetting/index.vue"
export default component.exports